import React, { useEffect, useState } from "react";
import allImages from "../../../assets/images-import";
import { Link, useLocation } from "react-router-dom";
import { getMenus } from "../../../services/manageAccess";
import { handleErrors } from "../../../utils/errorHandler";
import * as bootstrap from "bootstrap";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

export const Navbar = () => {
  console.log(bootstrap);
  const [menus, setMenus] = useState([]);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await getMenus();
        const filteredMenus = response.data.result.filter(
          (menu) => menu.showInMenu
        );
        setMenus(filteredMenus);
      } catch (error) {
        handleErrors(error);
      }
    };
    fetchMenus();
  }, []);

  const groupedMenus = menus.reduce((acc, menu) => {
    if (!acc[menu.pageGroupName]) {
      acc[menu.pageGroupName] = [];
    }
    acc[menu.pageGroupName].push(menu);
    return acc;
  }, {});

  return (
    <div className="app-menu navbar-menu sidebar-layout">
      <div className="navbar-brand-box">
        <a href="/" className="logo logo-dark">
          <span className="logo-sm">
            <img src={allImages.logoIcon} alt="" height="50" />
          </span>
          <span className="logo-lg">
            <img src={allImages.logoDark} alt="" height="80" />
          </span>
        </a>
        <a href="/" className="logo logo-light">
          <span className="logo-sm">
            <img src={allImages.logoSm} alt="" height="80" />
          </span>
          <span className="logo-lg">
            <img
              src={allImages.logoLight}
              alt="Bulk Liquid Solutions"
              className="sidebar-logo-light"
            />
          </span>
        </a>
        <button
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          id="vertical-hover"
        >
          <i className="ri-record-circle-line"></i>
        </button>
      </div>

      <div className="sidebar-menu-scroll">
        <SimpleBar id="scrollbar" style={{ height: "100%" }}>
          <div className="menu-title">
            <span data-key="t-menu">Menu</span>
          </div>
          <div className="container-fluid">
            <ul className="navbar-nav" id="navbar-nav">
              {Object.keys(groupedMenus).map((groupName, index) => {
                const groupItems = groupedMenus[groupName];
                const visiblePages = groupItems.filter((page) => page.showInMenu);

                return (
                  <li className="nav-item" key={index}>
                    {visiblePages.length > 1 ? (
                      <>
                        <a
                          className="nav-link menu-link"
                          href={`#sidebar${groupName.replace(/\s+/g, "")}`}
                          data-bs-toggle="collapse"
                          role="button"
                          aria-expanded="false"
                          aria-controls={`sidebar${groupName.replace(
                            /\s+/g,
                            ""
                          )}`}
                        >
                          <i
                            dangerouslySetInnerHTML={{
                              __html: groupItems[0].groupIcon,
                            }}
                          ></i>
                          <span>{groupName}</span>
                        </a>
                        <div
                          className="collapse menu-dropdown"
                          id={`sidebar${groupName.replace(/\s+/g, "")}`}
                        >
                          <ul className="nav nav-sm flex-column">
                            {visiblePages.map((page) => (
                              <li
                                className={`nav-item ${
                                  isActive(`/${page.pageLink}`) ? "active" : ""
                                }`}
                                key={page.pageId}
                              >
                                <Link
                                  to={`/${page.pageLink}`}
                                  className="nav-link"
                                  data-key={page.pageDesc}
                                >
                                  {page.pageName}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </>
                    ) : (
                      <Link
                        to={`/${visiblePages[0].pageLink}`}
                        className="nav-link menu-link"
                      >
                        <i
                          dangerouslySetInnerHTML={{
                            __html: groupItems[0].groupIcon,
                          }}
                        ></i>
                        <span>{groupName}</span>
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </SimpleBar>
      </div>

      <div className="sidebar-promo-wrap my-3 mx-3 mb-3">
        <div className="card border-0 shadow-none sidebar-promo-card">
          <div className="card-body text-center p-3">
            <div className="mb-3">
              <span
                className="avatar-md d-inline-flex align-items-center justify-content-center rounded"
                style={{ backgroundColor: "rgba(255,255,255,0.1)" }}
              >
                <i className="ri-bar-chart-grouped-line fs-24 text-primary"></i>
              </span>
            </div>
            <h6 className="fs-14 mb-1 sidebar-promo-title">Grow your business</h6>
            <p className="fs-12 mb-3 sidebar-promo-text">
              Manage your store efficiently and keep track of everything in one
              place.
            </p>
            <Link to="/dashboard" className="btn btn-primary btn-sm w-100">
              Go to Dashboard{" "}
              <i className="ri-arrow-right-line align-middle ms-1"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="sidebar-background"></div>
    </div>
  );
};
